import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject, filter, take } from 'rxjs';
import { MarketplacePageComponent } from 'src/app/customers/marketplace/marketplace.component';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { User } from 'src/app/shareModule/models/user.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { MemberNotificationService } from 'src/app/shareModule/services/member-notification.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { AppState } from 'src/app/shareModule/states/app.state';
import { selectUser } from 'src/app/shareModule/states/user-details';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-individual-rental',
  templateUrl: './individual-rental.component.html',
  styleUrls: ['./individual-rental.component.scss']
})
export class IndividualRentalComponent implements OnInit, OnDestroy {
  private destroy$ = new BehaviorSubject<void>(null);
  @ViewChild('marketplace') marketplaceProfileSection: MarketplacePageComponent;
  public selectedMemberRegion: string = '';
  carouselOptions: any = {
    nav: true,
    navText: [
      '<i class="fas fa-chevron-left"></i>',
      '<i class="fas fa-chevron-right"></i>',
    ],
    margin: 10,
    autoWidth: true,
  };
  allProduct: any;
  allProductByRegion: any = [];
  adsList: any;
  public imgUrl = environment.ImageUrl;
  public isLogin: any = 0;
  width: any = 0;
  // noDonations: boolean = false;
  // noRental: boolean = false;
  latLong: any = {};
  loading: boolean = false;
  search: string = ''
  constructor(
    public roleService: RoleService,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private sharedService: SharedService,
    private memberNotificationService: MemberNotificationService,
    private router: Router,
    private customerService: CustomerService,
    private store: Store<AppState>,
    @Inject("WINDOW") private window: any,
  ) { }

  ngOnInit(): void {
    this.loading = true
    this.width = this.window.innerWidth
    this.local.getUserDetailsObserver().subscribe(async user => {
      if (user?.id) {
        this.isLogin = 1
        this.latLong = user.latLong

      } else {
        this.isLogin = 0
      }
    });

    this.store.pipe(select(selectUser)).pipe(filter(user => !!user)).subscribe((r: User) => {
      if (r?.regionName) {
        this.selectedMemberRegion = r.regionName;
        this._getMemberShopProduct(this.selectedMemberRegion);
        this.getAds('', this.selectedMemberRegion);
      } else {

        this.loading = false
      }
    });
  }

  ngOnDestroy(): void {
    console.log('[Start Destroy] Individual Rental')
    this.local.clearTimeout(this.timeout1)
    this.destroy$.next();
    this.destroy$.complete();
    console.log('[End Destroy] Individual Rental')
  }

  timeout1: any;
  openShopPopup(name) {
    this.sharedService.triggerInitTabProfile('shop');
    this.local.clearTimeout(this.timeout1)
    this.timeout1 = setTimeout(() => {
      this.sharedService.triggerInitMarketProfile(name);
    }, 100);
  }


  public regionSplit(name: string): string {
    return name && name.includes("|") ? name.split("|")[1] : "";
  }
  public getAds(category: string, memberShopSubRegion: string): void {
    this.auth.getMemberShopAdsBy(category, memberShopSubRegion).subscribe((resp: ApiResponse) => {
      this.adsList = resp.body;
    });
  }


  _getMemberShopProduct(regionName) {
    console.log("FETCH getMemberShopProductList 6")
    this.customerService.getMemberShopProductList({ categoryId: "", subCategoryId: "", search: this.search, limit: 1008 }).subscribe((response: ApiResponse) => {
      this.allProduct = response.body.data

      this.local.checkDistanceProducts(this.allProduct, this.latLong)
      this.local.sortByNearestAndHigherPoints(this.allProduct)
      this.allProductByRegion = this.allProduct.filter((i) => (i.subRegionName == regionName))
      this.loading = false
      // this.noDonations = this.allProductByRegion.filter((i) => (i.type == 'bless'))?.length ? false : true
      // this.noRental = this.allProductByRegion.filter((i) => (i.type == 'rental'))?.length ? false : true
    }, (e) => {
      this.allProduct = []
      this.loading = false
    });
  }

  public viewProductDetails(product): void {
    this.marketplaceProfileSection.enableMemberShop = true;
    this.marketplaceProfileSection.viewProduct(product);
  }

  handleSearch(event: any): void {
    this.search = event.target.value;
    this._getMemberShopProduct(this.selectedMemberRegion);
  }

}
